
import { defineComponent } from "vue";
import { UserRoleEnum }  from "@/model/enums/UserRoleEnum";

export default defineComponent( {
  name: "UserRoleSelect",
  props: ["modelValue", "showAdmin", "multi"],
  data() {
    return {
      commonOptions: [
        {
          value: UserRoleEnum.DRIVER_OWNER_OPERATOR,
          label: 'Driver Owner Operator'
        },
        {
          value: UserRoleEnum.DRIVER,
          label: 'Driver'
        }
      ]
    }
  },
  computed: {
    selectVal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    options() {
      if(this.showAdmin){
        return this.commonOptions.concat({
          value: UserRoleEnum.SUPER_ADMIN,
          label: 'Admin'
        })
      }
      return this.commonOptions
    },
  }

} )
